













































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getConversionAppInfoById, updateDocConversionApp, resetConversionAppKey } from '@/apps/open/services/doc_conversion'
import { ConfigInfo } from '@/apps/open/types/transform'
import { TRANSFORM_DOC_URL } from '@/apps/open/constants'
import AdminLayout from '@/apps/open/layout/AdminLayout.vue'
import InputFormDialogBody from '@/apps/open/components/DialogBodys/InputForm.vue'
import EmailAdminDialogBody from '@/apps/open/components/DialogBodys/EmailAdmin.vue'

@Component({
  components: {
    AdminLayout
  }
})
export default class Info extends Vue {
  breadcrumbs: any = [{
    name: '金山文档格式转换',
    routeName: 'doc-conversion-apps'
  }]

  tabs = [{
    name: '开发信息',
    key: 'info',
    showAction: true
  }]

  activeTab = this.tabs[0]

  app_id = ''
  appInfo: any = {}
  hideAppKey = true

  get curEnterprise () {
    return this.$store.getters['User/curEnterprise']
  }

  @Watch('appInfo')
  onModelChange (newValue: any, oldValue: any) {
    if (newValue !== oldValue) {
      this.breadcrumbs.push({
        name: newValue.app_name
      })
    }
  }

  async mounted () {
    this.app_id = this.$route.params['id']
    try {
      const params = {
        developer_id: this.curEnterprise.developer_id
      }
      const res = await getConversionAppInfoById(this.app_id, params)
      this.appInfo = res.data
    } catch (error) {
      this.$message.error(error.message)
    }
  }

  jumpDevDoc () {
    window.open(TRANSFORM_DOC_URL)
  }

  showEmailAdminDialog (function_id: number) {
    this.$dialog.show({
      title: '邮件管理',
      body: EmailAdminDialogBody,
      bodyProps: {
        function_id,
        is_wwo: true
      }
    })
  }

  switchAppKey () {
    this.hideAppKey = !this.hideAppKey
  }

  showResetAppKeyDialog () {
    const dialogBody = `
      <div class="desc">
        <div>确定重置APPKEY吗？</div>
        <div>重置后旧APPKEY会立即失效</div>
      </div>
    `
    this.$dialog.show({
      title: '重置APPKEY',
      body: dialogBody,
      buttons: [
        { text: '取消' },
        { text: '重置', type: 'primary', fn: this.resetAppKey }
      ]
    })
  }

  async resetAppKey () {
    try {
      const params = {
        developer_id: this.curEnterprise.developer_id
      }
      const resp = await resetConversionAppKey(this.app_id, params)
      const data = resp.data
      this.appInfo.app_key = data.app_key
      this.$message.success('重置APPKEY成功')
    } catch (error) {
      this.$message.error(error.message)
    }
    this.$dialog.close()
  }

  showUpdateNameDialog () {
    this.$dialog.show({
      title: '修改应用名',
      body: InputFormDialogBody,
      bodyProps: {
        value: this.appInfo.app_name,
        rules: [{ required: true, message: '请输入应用名', trigger: ['blur', 'change'] }],
        inputProps: { maxlength: '20' },
        submit: this.updateName
      },
      buttons: [
        { text: '取消' },
        { text: '确定', type: 'primary', event: 'onOk' }
      ]
    })
  }

  async updateName (appName: string) {
    try {
      const resp = await updateDocConversionApp({ app_name: appName }, this.app_id, { developer_id: this.curEnterprise.developer_id })
      const data = resp.data
      this.appInfo.app_name = data.app_name
      this.$message.success('应用名修改成功')
    } catch (error) {
      this.$message.error(error.message)
    }
    this.$dialog.close()
  }
}
